import React from 'react';

const NotificationIcon = ({ count }) => {
	return (
		<div className='noti-wrapper'>
			<span>{count}</span>
		</div>
	);
};

export default NotificationIcon;
